module.exports = __webpack_public_path__ + "img/guideline_2.506c4c88.jpg";